// extracted by css-extract-rspack-plugin
export default {"p":"p-xA8DUJ","monthPickerBox":"monthPickerBox-cNyYAU"};